import { FC } from "react";
import "./../../assets/css/Payments/payments.css";
import { Helmet } from "react-helmet";
import Pricing from "./components/Pricing";

const PricingScreen: FC<{}> = () => {
  return (
    <>
      <Helmet>
        <title>Lokalny Trener - Cennik</title>
        <meta
          name="description"
          content="Sprawdź nasze plany cenowe na Lokalny Trener. Wybierz opcję, która najlepiej odpowiada Twoim potrzebom, aby oferować usługi eksperckie i znajdować klientów."
        />
        <meta
          name="keywords"
          content="cennik, plany cenowe, ceny, subskrypcja, lokalni eksperci, fitness, języki obce, korepetycje, programowanie"
        />
        <meta property="og:title" content="Lokalny Trener - Cennik" />
        <meta
          property="og:description"
          content="Sprawdź nasze plany cenowe na Lokalny Trener. Wybierz opcję, która najlepiej odpowiada Twoim potrzebom, aby oferować usługi eksperckie i znajdować klientów."
        />
        <meta
          property="og:url"
          content={`${process.env.REACT_APP_FRONTEND_URL}/pricing`}
        />
      </Helmet>
      <section>
        <div className="row">
          <Pricing />
        </div>
      </section>
    </>
  );
};

export default PricingScreen;
